export const Q_APP_DASHBOARD_GET = `
  query app_dashboard_get {
    app_dashboard_get
  }
`;

export const Q_APP_COURSE_DETAIL_GET = `
  query app_course_detail_get($course_id: String) {
    app_course_detail_get(course_id: $course_id)
  }
`;

export const Q_APP_COURSE_UNIT_GET = `
  query app_course_unit_get($input: CourseUnitInput) {
    app_course_unit_get(input: $input)
  }`;

export const Q_APP_FIRST_LOAD_GET = `
  query app_first_load_get {
    app_first_load_get
  }
`;

export const Q_SEND_SURVEY_EMAIL = `
  query send_survey_email($input: [SurveyEmail]) {
    send_survey_email(input: $input)
  }
`;

export const Q_COMMENT_LIST = `
  query comment_list($course_id: String, $discussion_id: String, $page: Int, $page_size: Int) {
    comment_list(course_id: $course_id, discussion_id: $discussion_id, page: $page, page_size: $page_size) {
      total
      page
      page_size
      data {
        _id
        author_id
        author_name
        author_fullname
        avatar
        cover
        visible
        role
        type
        course_id
        discussion_id 
        course_title
        section_title
        sequence_title
        vertical_title
        body
        files
        vote_up_count
        vote_down_count
        created_at
        reply {
          author_id
          author_name
          author_fullname
          avatar
          cover
          visible
          role
          body
          files
          created_at
        }
      }
    }
  }
`;

export const M_COMMENT_CREATE = `
  mutation comment_create($input: CommentCreateInput) {
    comment_create(input: $input)
  }`;

export const M_COMMENT_EDIT = `
  mutation comment_edit($input: CommentEditInput) {
    comment_edit(input: $input)
  }`;

export const M_USER_EDIT = `
  mutation user_edit($input: [NameValue]) {
    user_edit(input: $input)
  }
`;

export const Q_MODULE_INSPECT_LIST = `
  query inspect_module_list($course_id: String, $page: Int, $page_size: Int) {
    inspect_module_list(course_id: $course_id, page: $page, page_size: $page_size) {
      total
      page
      page_size
      total_spent
      quiz_spent
      data {
        date
        details {
          module_title
          total_spent
          quiz_spent
          correct_count
          total_count
        }
      }
    }
  }
`;

export const M_MODULE_INSPECT_EDIT = `
  mutation module_inspect_edit($input: [ModuleInspectEditInput]) {
    module_inspect_edit(input: $input)
  }
`;

export const Q_GOOGLE_INSPECT_LIST = `
  query inspect_meeting_list($course_id: String, $page: Int, $page_size: Int) {
    inspect_meeting_list(course_id: $course_id, page: $page, page_size: $page_size) {
      total
      page
      page_size
      total_spent
      data {
        date
        details {
          event_id
          spent
          instructor_name
          attempts
        }
      }
    }
  }
`;

export const M_VIMEO_INSPECT_EDIT = `
  mutation vimeo_inspect_edit($input: VimeoInspectEditInput) {
    vimeo_inspect_edit(input: $input)
  }
`;

export const M_STUDENT_ANSWER_EDIT = `
  mutation user_answer_edit($input: [StudentAnswerInput]) {
    user_answer_edit(input: $input)
  }
`;

export const M_REVIEW_EDIT = `
  mutation review_edit($input: ReviewEditInput) {
    review_edit(input: $input)
  }
`;

export const M_CERTIFICATE_CREATE = `
  mutation certificate_create($input: CertificateInput) {
    certificate_create(input: $input)
  }
`;

export const Q_LOGIN_HISTORY_LIST = `
  query user_login_log_list($page: Int, $page_size: Int) {
    user_login_log_list(page: $page, page_size: $page_size) {
      total
      page
      page_size
      data {
        date
        device
        ip_address
        browser
      }
    }
  }
`;

export const Q_REPLAY_INSPECT_LIST = `
  query inspect_replay_list($course_id: String, $page: Int, $page_size: Int) {
    inspect_replay_list(course_id: $course_id, page: $page, page_size: $page_size) {
      total 
      page
      page_size
      total_spent
      data {
        date
        details {
          event_id
          file_id
          topic
          spent
          instructor_name
        }
      }
    }
  }
`;

export const M_REPLAY_INSPECT_EDIT = `
  mutation replay_inspect_edit($input: ReplayInspectEditInput) {
    replay_inspect_edit(input: $input)
  }
`;

export const Q_SEND_COACH_EMAIL = `
  query send_coach_email($email: String, $name: String, $html: String) {
    send_coach_email(email: $email, name: $name, html: $html)
  }
`;

export const Q_PAST_SESSION_LIST = `
  query meet_recording_list($course_id: String, $page: Int, $page_size: Int) {
    meet_recording_list(course_id: $course_id, page: $page, page_size: $page_size) {
      total
      page
      page_size
      data {
        id
        room
        file_id
        topic
        description
        start_time
        duration
        tutor_avatar
        tutor_name
      }
    }
  }
`;

/******************** Chat *********************/
export const Q_LIST_CHAT = `
  query chat_list($user_id: Int, $peer_id: Int, $page: Int, $page_size: Int) {
    chat_list(user_id: $user_id, peer_id: $peer_id, page: $page, page_size: $page_size) {
      message_more
      page
      messages {
        text
        urls
        to_admin
        from_id
        created
        updated
      }
    }
  }
`;

export const M_ADD_CHAT = `
  mutation chat_add($event_id: String, $urls: [String], $text: String, $created: String) {
    chat_add(event_id: $event_id, urls: $urls, text: $text, created: $created)
  }
`;

export const M_ADD_CHAT_BATCH = `
  mutation chat_add_batch($messages: [ChatAddInput]) {
    chat_add_batch(messages: $messages)
  }
`;

export const M_CHAT_TYPING = `
  mutation chat_typing($event_id: String, $typing: Boolean) {
    chat_typing(event_id: $event_id, typing: $typing)
  }
`;

export const M_PRESENCE_PING = `
  mutation presence_ping {
    presence_ping
  }
`;

export const M_PRESENCE_LEAVE = `
  mutation presence_leave {
    presence_leave
  }
`;

export const Q_NETWORK_LIST = `
  query network_list {
    network_list {
      user_id
      fullname
      username
      email
      avatar
      role
      location
      permission
      online
      last_seen
    }
  }
`;

/************* Chart  *******************/
export const Q_LIST_USER_CHART = `
  query user_chart_list($start: String, $end: String) {
    user_chart_list(start: $start, end: $end) {
      total_module_spent
      total_quiz_spent
      total_replay_spent
      total_virtual_spent
      data
      start
      end
    }
  }
`;

export const Q_ADMIN_USER_REPORT_GET = `
  query admin_user_report_get($user_id: Int) {
    admin_user_report_get(user_id: $user_id)
  }
`;
